.container {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  padding: 0 5px;
}

.buttonGroup {
  display: flex;
  align-items: center;
  gap: 5px;
}
